// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		typeof equalize !== "undefined" && equalize();

		// Offcanvas menu
		var navTrigger = document.getElementsByClassName('nav-trigger')[0],
			body = document.getElementsByTagName('body')[0];

		var navTriggerM = document.getElementsByClassName('nav-trigger')[1],
			body = document.getElementsByTagName('body')[0];

		var closeBtn = document.querySelector('.nav-trigger')[2],
			body = document.getElementsByTagName('body')[0];

		function toggleNavigation(e) {
			e.preventDefault();
			body.classList.toggle('nav-open');
		}

		navTrigger.addEventListener('click', toggleNavigation);
		navTriggerM.addEventListener('click', toggleNavigation);

		$('.scroll-section').on('click', function (e) {
			e.preventDefault();
			var href = $(this).attr('href');
			var current_div = $(href);
			var animateTo = $(".content-scroll").scrollTop() - $(".content-scroll").position().top + $(href).position().top;
			$('.content-scroll').animate(
				{ scrollTop: animateTo },
				"slow"
			);
		});

		//Slick Our Coffee
		$('.images-container').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			asNavFor: '.text-container .content'
		});
		$('.text-container .content').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.images-container',
			slide: '.text',
			dots: true,
			appendArrows: '.arrows-holder',
			appendDots: '.pagingInfo',
			fade: true,
			cssEase: 'linear'
		});
		// Collect all children
		var $children = $(".shortcodes-home").children("aside");

		// Collect all unique class names
		var classNames = $children.map(function() {
			return this.className;
		});
		classNames = $.unique(classNames.get());

		// Find all children with same class and wrap them
		$.each(classNames, function(i, className) {
			$children.filter(function() {
				return $(this).hasClass(className);
			}).wrapAll("<div class='column-hover' />");
		});
		//Slick mobile home
		$('.column-hover').slick({
			dots: true,
			arrows:false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			slide: '.hover-image',
			mobileFirst: 'true',
			accessibility: 'true',
			responsive: [
				{
					breakpoint: 1200,
					settings: 'unslick'
				},
				{
					breakpoint: 1024,
					settings: 'unslick'
				},
				{
					breakpoint: 800,
					settings: 'unslick'
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 2
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});

	});


	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
		// Lazy images menu
		var lazy_image = document.querySelectorAll('.image-hover');
		if (lazy_image) {
			//console.log(lazy_image);
			for (var l = 0; l < lazy_image.length; l++) {
				var data_src = lazy_image[l].dataset.src;
				lazy_image[l].setAttribute("src", data_src);
				lazy_image[l].removeAttribute('data-src');
				lazy_image[l].classList.add('loaded');
			}
		}
	};

	// Main Nav Dropdown toggle images
	let getItemMenu = [...document.querySelectorAll('#primary-nav li')] || [];
	let getImagesMenu = [...document.querySelectorAll('.image-hover')] || [];

	getItemMenu.forEach(function (itemMenu) {

		var item = function () {
			var objectClass;
			document.querySelectorAll('#primary-nav li a').forEach(function (item) {
				if (item.classList.contains('active')) {
					objectClass = item.parentElement.classList[1];
					item.parentElement.classList.add('active')
				}
			})
			return (objectClass);
		}

		itemMenu.addEventListener('mouseover', function () {

			itemMenu.classList.remove('hover');
			var itemActive;
			if (itemMenu.classList.contains('active')) {
				itemActive = itemMenu.classList[0];
			}
			let classItemMenu = itemMenu.classList[1];

			getImagesMenu.forEach(function (itemImage) {
				itemImage.classList.remove('show');
				if (itemImage.classList.contains(classItemMenu) || itemImage.classList.contains(itemActive)) {
					itemImage.classList.add('show');
				}
				else {
					itemImage.classList.remove('show');
				}
			})
		});

		itemMenu.addEventListener('mouseout', function () {
			getImagesMenu.forEach(function (itemImage) {
				if (itemImage.classList.contains(item())) {
					itemImage.classList.add('show');
				} else {
					itemImage.classList.remove('show');
					document.querySelector('.primary-nav-0').classList.add('show');
				}
			})
		})

		getImagesMenu.forEach(function (itemImage) {
			if (itemImage.classList.contains(item())) {
				itemImage.classList.add('show');
			} else {
				itemImage.classList.remove('show');
				document.querySelector('.primary-nav-0').classList.add('show');
			}
		})

	})
	// End Main Nav Dropdown toggle images

	// Append cont-signup on resize
	var footerCont = document.getElementById('cnt-row');
	var signupCont = document.getElementById('sign-up-cont');
	var secondaryNav = document.getElementById('c-secondary-nav');
	window.addEventListener("resize", function () {
		if (window.innerWidth < 768) {
			footerCont.appendChild(signupCont);
		}
		else {
			secondaryNav.appendChild(signupCont);
		}
	});
	if (window.innerWidth < 768) {
		footerCont.appendChild(signupCont);
	}
	else {
		secondaryNav.appendChild(signupCont);
	}


}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.getElementById('menu-mobile').classList.add('down');
				document.getElementById('menu-mobile').classList.remove('up');


			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				//document.getElementById('menu-mobile').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			document.getElementById('menu-mobile').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

